import { render, staticRenderFns } from "./EventSummary.vue?vue&type=template&id=3c38fe42&scoped=true&"
import script from "./EventSummary.vue?vue&type=script&lang=js&"
export * from "./EventSummary.vue?vue&type=script&lang=js&"
import style0 from "./EventSummary.vue?vue&type=style&index=0&id=3c38fe42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38fe42",
  null
  
)

component.options.__file = "EventSummary.vue"
export default component.exports